import React from 'react';
import './EmptyCart.css';

import { Button } from '../../components'; // Importing the Button component
import { FaCartArrowDown } from 'react-icons/fa'; // Importing the cart icon from react-icons

const EmptyCart = (props) => {

  // Destructuring props to extract the title
  const { title } = props;

  return (
    // Container for the empty cart message
    <div className='empty-cart'>
      <div><FaCartArrowDown className='icon' /></div> {/* Displaying the cart icon */}
      <h3>{title}</h3> {/* Displaying the title passed as a prop */}
      <Button link={'Shop-List'} title={'shop now'} /> {/* Button to redirect to the shop page */}
    </div>
  );

};

export default EmptyCart;